import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { IInfrastructure } from "@src/store/entities";
import { Button, Carousel, Skeleton, Tooltip } from "antd";
import { CarouselRef } from "antd/es/carousel";
import React, { useRef } from "react";
import './rrt-cat-slider.css';

const RrtCatSlider = ({...props}) => {
  const {currentCat, title, actTitle, actClick, actPrice} = props;
  const ref0 = useRef<CarouselRef>(null);

  const SlickArrowLeft0 = () => <Button aria-hidden='true' shape='circle' icon={<LeftOutlined />} className="slick-arrow slick-prev" onClick={() => ref0.current?.prev()}/>
  const SlickArrowRight0 = () => <Button aria-hidden='true' shape='circle' icon={<RightOutlined />} className="slick-arrow slick-next" onClick={() => ref0.current?.next()}/>
  const gallery = currentCat?.gallery || [];
  const infras = currentCat?.infrastructure || [];
  const visibleInfras = infras.slice(0, 8);
  const extraInfraCount = Math.max(0, infras.length - visibleInfras.length);

  return currentCat ? <div className='rrt-cat-slider'>
      {title && <div className='rrt-cat-slider-kicker'>{title}</div>}
      <div className='rrt-cat-slider-body'>
          <div className='rrt-cat-slider-gallery'>
              {gallery.length > 0 ? <Carousel arrows={true} prevArrow={<SlickArrowLeft0 />} nextArrow={<SlickArrowRight0 />} slidesToScroll={1} ref={ref0}>
                  {gallery.map((i:any) => {
                      const fileName = i.imageFileName ? `${process.env.REACT_APP_API_BASE_URL}/api/image${i.imageFileName}` : i.source;
                      return <div key={i.imageId}>
                          <div className='rrt-cat-slider-image'>
                              <img src={fileName} alt={currentCat.name || "Фото категории"}/>
                          </div>
                      </div>
                  })}
              </Carousel> : <Skeleton.Image active />}
          </div>
          <div className='rrt-cat-slider-info'>
            <div className='reserve-section-title'>{currentCat.name}</div>
            {currentCat.description && <div className='reserve-hotel-description'>{currentCat.description}</div>}
            {visibleInfras.length > 0 && <div className='rrt-cat-slider-infra'>
                {visibleInfras.map((e: IInfrastructure) => <Tooltip title={e.name} key={e.infrastructureID}>
                    <span className='rrt-cat-slider-infra-item'>
                        <img src={`${process.env.REACT_APP_API_BASE_URL}/api/image${e.imageFileName}`} alt={e.name}/>
                    </span>
                </Tooltip>)}
                {extraInfraCount > 0 && <span className='rrt-cat-slider-infra-more'>+{extraInfraCount}</span>}
            </div>}
            {(actPrice || actTitle) && <div className='rrt-cat-slider-action'>
                {actPrice ? <div className='reserver-hotel-tariff-price'>+ {actPrice.toLocaleString('ru-RU')} ₽</div> : <div />}
                {actTitle && <Button onClick={actClick} className='action-button'>{actTitle}</Button>}
            </div>}
          </div>
      </div>
  </div> : <div className='reserve-section-title'>Категория размещения не выбрана</div>
}

export default RrtCatSlider;
